import { render } from "./InventoryAvailableItemsReports.vue?vue&type=template&id=712a81ab&ts=true"
import script from "./InventoryAvailableItemsReports.vue?vue&type=script&lang=ts"
export * from "./InventoryAvailableItemsReports.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__